export const config = {
  element: {
    1: 'h1',
    2: 'h2',
    3: 'h3',
    4: 'h4',
    5: 'h5',
  },
  style: {
    size: {
      1: 'Heading--1',
      2: 'Heading--2',
      3: 'Heading--3',
      4: 'Heading--4',
      5: 'Heading--5',
    },
    align: {
      center: 'Heading--center',
    },
  },
};
